
import AddressContract from '../contracts/Address';
import Resource from './Resource';

/**
 * Address class
 * @class
 **/
class Address extends Resource implements AddressContract
{
    /**
     * Resource identifier
     * @type {String}
     **/
    static handle = 'address_id';

    /**
     * Default attributes
     * @type {Object}
     **/
    static attributes: AddressContract = {
        fullname: undefined,
        line1: undefined,
        line2: undefined,
        city: undefined,
        county: undefined,
        country: 'GB',
        postcode: undefined,
    };

    /**
     * Resource attributes
     * @type {AddressContract}
     **/
    protected attributes: AddressContract;

    /**
     * Current attributes
     */
    fullname: string;
    line1: string;
    line2: string;
    city: string;
    county: string;
    country: string;
    postcode: string;

    /**
     * Get resource validation rules
     * @return {Object}
     * */
    rules(): any
    {
        return {
            fullname: ['required'],
        };
    }
}

Resource.register( Address );

export default Address;
